import { render, staticRenderFns } from "./PixTransactions.vue?vue&type=template&id=0c48074a&"
import script from "./PixTransactions.vue?vue&type=script&lang=js&"
export * from "./PixTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PixTransactions.vue?vue&type=style&index=0&id=0c48074a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c48074a')) {
      api.createRecord('0c48074a', component.options)
    } else {
      api.reload('0c48074a', component.options)
    }
    module.hot.accept("./PixTransactions.vue?vue&type=template&id=0c48074a&", function () {
      api.rerender('0c48074a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PixTransactions.vue"
export default component.exports